<template>
  <div id="P404">
    <p id="errorNumber">
      404
    </p>
    <div id="subText">
      <p>
        You seem to be a bit lost.
      </p>
      <div id="backHome">
        <p>
          Back&nbsp;
        </p>
        <router-link to="/" id="homeButton" class="underLineW">home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../utils/Loader.js'

export default {
  name: 'P404',
  mounted(){
    const loader = new Loader()
    loader.close()

    document.title = `SI. /404`
  }
}
</script>

<style scoped>
#P404
{  
  font-family: 'Inter', sans-serif;
  color: #f5f5f5;
  background-color: #111111;
  min-height: 100vh;
}
#errorNumber
{
  margin: 0;
}
#backHome
{
  display: flex;
  flex-direction: row;
  width: min-content;
}
#homeButton,
#subText p
{
  margin: 0;
  margin-top: 0.5em;
}
@media screen and (orientation: landscape)
{
  #P404
  {
    padding: 10vh;
  }
  #errorNumber
  {  
    font-size: 30vh;
  }
  #subText
  {
    margin-left: 5vh;
  }
  #homeButton,
  #subText p
  {
    font-size: 4vh;
  }
}
@media screen and (orientation: portrait)
{
  #P404
  {
    padding: 15vw;
  }
  #errorNumber
  {  
    font-size: 30vw;
  }  
  #subText
  {
    margin-left: 5vw;
  }
  #homeButton,
  #subText p
  {
    font-size: 5vw;
  }
}
</style>